const ModularPreview = {
  parts: [
    'container',
    'containerInner',
    'headerSection',
    'titleGroup',
    'eyebrow',
    'title',
    'description',
    'imageContainer',
    'imageWrapper',
    'image',
    'tabsContainer',
    'tabButton',
    'tabIcon'
  ],
  baseStyle: {
    container: {
      bg: 'white',
      overflow: 'hidden',
      position: 'relative',
    },
    containerInner: {
      maxWidth: '1440px',
      mx: 'auto',
      display: 'flex',
      pt: {base: 12, md: 30},
      pb: {base: 12, md: 20},
      px: {base: 5, md: 0},
      flexDirection: 'column',
      alignItems: 'center',
      gap: {base: 4, md: 0},
      alignSelf: 'stretch',
    },
    headerSection: {
      display: 'flex',
      width: {base: 'full', md: '840px'},
      flexDirection: 'column',
      alignItems: 'center',
      gap: {base: 4, md: 4},
      mb: {base: 0, md: 10},
    },
    titleGroup: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: {base: 3, md: 3},
      alignSelf: 'stretch',
    },
    eyebrow: {
      width: 'full',
      color: 'brandColors.charcoal',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: '2xs', md: 'sm'},
      fontWeight: 'medium',
      lineHeight: '140%',
      letterSpacing: {base: '1.2px', md: '1.4px'},
      textTransform: 'uppercase',
    },
    title: {
      alignSelf: 'stretch',
      color: 'brandColors.charcoal',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '5xl'},
      fontWeight: 'medium',
      lineHeight: '120%',
      mb: 0,
    },
    description: {
      alignSelf: 'stretch',
      color: 'brandColors.charcoal',
      textAlign: 'center',
      fontFamily: 'body',
      fontSize: {base: 'md', md: 'xl'},
      fontWeight: 'normal',
      lineHeight: '150%',
    },
    imageContainer: {
      position: 'relative',
      width: 'full',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      mb: {base: 4, md: 16},
      aspectRatio: {base: '335/190', md: '1440/400'},
    },
    imageWrapper: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 'full',
      height: 'full',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'opacity 0.3s ease-in-out',
    },
    image: {
      width: 'auto',
      height: 'full',
      maxWidth: '100%',
      objectFit: 'contain',
    },
    tabsContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: {base: 6.5, md: 14},
      justifyContent: 'center',
    },
    tabButton: {
      display: 'flex',
      cursor: 'pointer',
    },
    tabIcon: {
      transition: 'opacity 0.2s ease',
    },
  },
};

export default ModularPreview;
